import moment from 'moment';
import { setRemarketingTag } from 'ha/modules/Analytics/actions';

import { ACCEPT } from '../constants/Actions';
import { makeRequestAction } from './actions';

export default conversationId => (dispatch, _, { apiV2 }) => {
  dispatch(makeRequestAction.start({ type: ACCEPT }));

  return apiV2
    .acceptTenant(conversationId)
    .then(({ data }) =>
      apiV2
        .getConversationMessages(conversationId)
        .then(messages => [data, messages]),
    )
    .then(([data, { data: { messages } }]) => {
      dispatch(
        setRemarketingTag({
          hrental_id: data.listingId,
          hrental_pagetype: 'proposalsent',
          hrental_startdate: moment(data.startDate).format('YYYY-MM-DD'),
          hrental_enddate: moment(data.endDate).format('YYYY-MM-DD'),
          hrental_totalvalue: data.total,
        }),
      );

      dispatch(makeRequestAction.done({ ...data, messages }));
    })
    .catch(error => dispatch(makeRequestAction.error(error)));
};
